import { useHistory } from "react-router-dom";
import clsx from "clsx";
import styles from "./NonEditableMask.module.scss";

interface NonEditableMaskProps {
  isMasked: boolean;
}

const NonEditableMask = (props: NonEditableMaskProps) => {
  const history = useHistory();

  const handleGoBack = () => {
    if (props.isMasked) {
      history.goBack();
    }
  };

  return (
    <div
      onClick={handleGoBack}
      className={clsx({
        [styles.opaqueMask]: props.isMasked,
      })}
    >
      {props.isMasked && (
        <div className={styles.returnLabel}>Click here to return</div>
      )}
    </div>
  );
};

export default NonEditableMask;
